export default __webpack_public_path__ + "static/male1-f75a687d6d7b20836dc902e535085a47.png";